"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invoice = void 0;
const mobx_1 = require("mobx");
const patient_payment_balance_1 = require("shared/patient-payment-balance");
const print_util_1 = require("../../print-util");
const moment = require("moment-timezone");
/**
 * Page 3
 * - Invoice
 */
class Invoice extends print_util_1.PrintUtil {
    constructor(printMeta, lastPage) {
        super();
        this.printMeta = printMeta;
        this.lastPage = lastPage;
        this.make = () => {
            var _a, _b, _c, _d, _e, _f;
            const { claim, barcode, patientSignature, historic } = this.printMeta;
            const currentClaim = mobx_1.toJS(claim);
            const order = currentClaim.order;
            const inventoryItem = (_a = historic === null || historic === void 0 ? void 0 : historic.inventoryData) !== null && _a !== void 0 ? _a : currentClaim.inventory;
            const provider = (_b = historic === null || historic === void 0 ? void 0 : historic.providerData) !== null && _b !== void 0 ? _b : order.provider;
            const site = (_c = historic === null || historic === void 0 ? void 0 : historic.siteData) !== null && _c !== void 0 ? _c : order.site;
            const claimLots = currentClaim.claimLots;
            const paymentAmount = patient_payment_balance_1.sumNetPaymentsCents(currentClaim.payments || []);
            const paidClaimAmt = (((_d = currentClaim.payments) === null || _d === void 0 ? void 0 : _d.length) ? paymentAmount / 100 : 0).toFixed(2); // D-002.54 D-002.58 — net paid after void/refund
            const totalPriceInsurance = (((_f = (_e = currentClaim.copay) === null || _e === void 0 ? void 0 : _e.newPatientAmount) !== null && _f !== void 0 ? _f : currentClaim.patientAmount) /
                100 || 0).toFixed(2);
            const totalPriceCash = (inventoryItem.priceCash * currentClaim.quantity || 0).toFixed(2);
            const totalPrice = currentClaim.responses !== null ? totalPriceInsurance : totalPriceCash;
            const pageBreak = this.lastPage ? "" : "after";
            const balanceDue = (totalPrice - paidClaimAmt).toFixed(2); // D-002.54
            // D-002.54 related to update the payment amount in the invoices. 
            // D-002.58 Need card payment tracking information on receipt
            return [
                {
                    style: "tableText",
                    layout: {
                        hLineWidth(i, node) {
                            return 0;
                        },
                        vLineWidth(i, node) {
                            return 0;
                        }
                    },
                    table: {
                        widths: [250, 267],
                        headerRows: 0,
                        body: [
                            [
                                {
                                    stack: [
                                        `${provider.lastName || ""} ${provider.firstName ||
                                            ""} ${provider.title || ""}`,
                                        `${site.name || ""}`,
                                        `${site.address || ""}`,
                                        `${site.city || ""}, ${site.state || ""} ${site.zip || ""}`,
                                        `Phone: ${(site.phone || "").replace(/\D+/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")}`
                                    ],
                                    style: { bold: true }
                                },
                                {
                                    stack: [
                                        {
                                            layout: {
                                                hLineWidth(i, node) {
                                                    return 0;
                                                },
                                                vLineWidth(i, node) {
                                                    return 0;
                                                }
                                            },
                                            table: {
                                                widths: [100, 100],
                                                headerRows: 1,
                                                body: [
                                                    [
                                                        { text: "Date", style: { bold: true } },
                                                        {
                                                            text: "Order Number",
                                                            style: { bold: true, alignment: "right" }
                                                        }
                                                    ],
                                                    [
                                                        {
                                                            text: `${this.currentDate() || ""} ${this.currentTime() || ""}`
                                                        },
                                                        {
                                                            text: `${claim.rxId.rxId || ""}`,
                                                            style: "rightAlign"
                                                        }
                                                    ]
                                                ]
                                            }
                                        },
                                        { image: barcode, width: 100 }
                                    ],
                                    style: { bold: true, alignment: "center" }
                                }
                            ]
                        ]
                    }
                },
                {
                    style: "tableText",
                    table: {
                        headerRows: 1,
                        widths: [415, 15, 80],
                        body: [
                            [
                                { text: "Item", style: { bold: true } },
                                { text: "Qty", style: { bold: true, alignment: "right" } },
                                { text: "Amount", style: { bold: true, alignment: "right" } }
                            ],
                            [
                                {
                                    stack: [
                                        `${inventoryItem.name || ""}`,
                                        {
                                            text: `Rx #:${claim.rxId.rxId || ""}-${claim.fillNumber} NDC:${inventoryItem.package || ""} Lot#:${claimLots
                                                .map((cLot) => cLot.siteLot.lotNumber)
                                                .join(", ") ||
                                                ""} Exp: ${claimLots
                                                .map((cLot) => moment(cLot.siteLot.expirationDate).format("MM/DD/YYYY"))
                                                .join(", ") || ""}`,
                                            style: "RxRow"
                                        }
                                    ]
                                },
                                {
                                    text: `${claim.quantity * inventoryItem.disQty || ""}`,
                                    style: "rightAlign"
                                },
                                { text: `${totalPrice}`, style: "rightAlign" }
                            ],
                            [
                                { stack: [
                                        { text: "Payment Information", style: { bold: true } },
                                        { text: `Patient Name : ${currentClaim.order.patient.lastName} ${currentClaim.order.patient.firstName}`, style: { bold: true } },
                                        { text: [{ text: "" }], margin: [0, 0, 0, 4] },
                                        ...(currentClaim.payments || []).flatMap((payment, index) => this.paymentTransactionPdfLines(payment, index, site, (p) => this.formatInvoicePaymentNo(p.sitePay)))
                                    ] },
                                "",
                                {
                                    stack: [
                                        `Subtotal: $${totalPrice}`,
                                        "Tax: $0.00",
                                        `Total: $${totalPrice}`,
                                        `Payment: $${paidClaimAmt}`,
                                        `Balance Due: $${balanceDue}`
                                    ],
                                    style: { alignment: "right" }
                                }
                            ]
                        ]
                    }
                },
                // Patient Acknowledgement Table
                {
                    style: "tableText",
                    layout: {
                        hLineWidth(i, node) {
                            return i === 0 || i === node.table.body.length ? 1 : 0;
                        },
                        vLineWidth(i, node) {
                            return i === 0 || i === node.table.widths.length ? 1 : 0;
                        }
                    },
                    table: {
                        headerRows: 1,
                        widths: "auto",
                        body: [
                            ["Patient Acknowledgement"],
                            [
                                {
                                    text: "By signing, patient acknowledges receipt of and instruction on the use " +
                                        "and contraindictions of the product(s) listed above. If payment has been " +
                                        "made by credit card, patient agrees to pay the above amount according to the " +
                                        "card issuer agreement. Patient acknowledges medications may not be returned and " +
                                        "that all sales are final.",
                                    style: "acknowledgement"
                                }
                            ],
                            [
                                {
                                    stack: [
                                        {
                                            image: patientSignature,
                                            width: 100,
                                            relativePosition: { x: 75, y: -10 }
                                        },
                                        {
                                            text: "Patient Signature:                                                        ",
                                            style: "underline"
                                            // relativePosition: {x: 10, y: 0}
                                        }
                                    ]
                                }
                            ]
                        ]
                    },
                    pageBreak
                }
            ];
        };
    }
}
exports.Invoice = Invoice;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/sheets/invoice/invoice.ts
// module id = 2734
// module chunks = 0 1